<div class="ex-wrap">

  <header class="ex-intro">
    <h3>Hidden users</h3>
    <p>
      Anyone added here is hidden from every employee-facing screen — the Employee Tree,
      directories, dashboards and reports. Use it for service accounts and admin logins that
      shouldn't appear as staff. Nothing is deleted: remove the entry and they reappear.
    </p>
  </header>

  <div class="ex-add">
    <div class="ex-picker">
      <span class="ex-label" id="ex-lbl">Find an employee</span>

      <div class="ex-input" [class.is-open]="open" [class.is-picked]="picked">
        <span class="material-icons ex-input-ic">{{ picked ? 'person' : 'search' }}</span>

        <input
          type="text"
          [(ngModel)]="query"
          (ngModelChange)="onQueryChange()"
          (keydown)="onKeydown($event)"
          (focus)="onQueryChange()"
          [disabled]="saving"
          placeholder="Search by name, email or employee ID…"
          autocomplete="off"
          role="combobox"
          aria-autocomplete="list"
          aria-labelledby="ex-lbl"
          [attr.aria-expanded]="open" />

        <button type="button" class="ex-clear" *ngIf="query" (click)="clear()" aria-label="Clear">
          <span class="material-icons">close</span>
        </button>

        <ul class="ex-menu" *ngIf="open && results.length" role="listbox">
          <li *ngFor="let e of results; let i = index; trackBy: trackById"
              role="option"
              [attr.aria-selected]="i === highlighted">
            <button type="button"
                    class="ex-opt"
                    [class.is-hl]="i === highlighted"
                    (mouseenter)="highlighted = i"
                    (click)="pick(e)">
              <span class="ex-av ex-av--sm">{{ initials(e) }}</span>
              <span class="ex-opt-txt">
                <span class="ex-opt-name">{{ fullName(e) }}</span>
                <span class="ex-opt-meta">{{ e.email }}</span>
              </span>
              <span class="ex-opt-desig" *ngIf="e.designation">{{ e.designation }}</span>
            </button>
          </li>
        </ul>

        <div class="ex-menu ex-menu--empty" *ngIf="open && !results.length">
          No matching employee.
        </div>
      </div>
    </div>

    <button type="button" class="ex-add-btn" [disabled]="!picked || saving" (click)="add()">
      <span class="material-icons">visibility_off</span>
      {{ saving ? 'Hiding…' : 'Hide user' }}
    </button>
  </div>

  <div class="ex-loading" *ngIf="loading">Loading…</div>

  <div class="ex-empty" *ngIf="!loading && !excluded.length">
    <span class="material-icons">visibility</span>
    <p>No exceptions. Every active employee is visible.</p>
  </div>

  <ul class="ex-list" *ngIf="!loading && excluded.length">
    <li class="ex-item" *ngFor="let e of excluded; trackBy: trackById">
      <span class="ex-av">{{ initials(e) }}</span>
      <span class="ex-txt">
        <span class="ex-name">{{ fullName(e) }}</span>
        <span class="ex-mail">{{ e.email }}</span>
      </span>
      <span class="ex-tag"><span class="material-icons">visibility_off</span> Hidden</span>
      <button type="button" class="ex-rm" (click)="remove(e)" [attr.aria-label]="'Remove ' + fullName(e)">
        <span class="material-icons">close</span>
      </button>
    </li>
  </ul>

</div>
